import { ChatMessageUser } from '@/components'
import type { UserMessageAttachment } from '@/components'
import type { MessageStatus } from '../api'

interface BotMessageUserProps {
  content: string
  status?: MessageStatus
  attachments?: UserMessageAttachment[]
}

export default function BotMessageUser({ content, status: _status, attachments }: BotMessageUserProps) {
  return (
    <ChatMessageUser
      message={{
        id: 0,
        type: 'user',
        content,
        attachments,
      }}
    />
  )
}
